module.exports = __webpack_public_path__ + "static/media/experiences-in-the-spotlight.63bfdea1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/img/experiences-in-the-spotlight.jpg
// module id = 442
// module chunks = 0